export default __webpack_public_path__ + "static/media/icon_cloud.ad2e75f9.svg";